import type { TeamContent } from '@mawkaa/types';
import { User } from 'lucide-react';

interface TeamBlockProps {
  content: TeamContent;
  isEditing?: boolean;
}

export function TeamBlock({ content, isEditing }: TeamBlockProps) {
  const { title, subtitle, members = [] } = content;

  if (members.length === 0) {
    return (
      <section className="px-4 py-16 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold">{title || 'Notre Équipe'}</h2>
            {subtitle && <p className="mt-4 text-lg text-muted-foreground">{subtitle}</p>}
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="text-center">
                <div className="w-32 h-32 mx-auto bg-gray-200 rounded-full flex items-center justify-center mb-4">
                  <User className="w-12 h-12 text-gray-400" />
                </div>
                <div className="h-4 bg-gray-200 rounded w-24 mx-auto mb-2" />
                <div className="h-3 bg-gray-200 rounded w-20 mx-auto" />
              </div>
            ))}
          </div>
          {isEditing && (
            <p className="text-center text-muted-foreground mt-8">
              Ajoutez les membres de votre équipe
            </p>
          )}
        </div>
      </section>
    );
  }

  return (
    <section className="px-4 py-16 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold">{title}</h2>
          {subtitle && <p className="mt-4 text-lg text-muted-foreground">{subtitle}</p>}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
          {members.map((member, index) => (
            <div key={index} className="text-center">
              {member.image ? (
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 mx-auto rounded-full object-cover mb-4"
                />
              ) : (
                <div className="w-32 h-32 mx-auto bg-gray-200 rounded-full flex items-center justify-center mb-4">
                  <User className="w-12 h-12 text-gray-400" />
                </div>
              )}
              <h3 className="font-semibold text-lg">{member.name}</h3>
              <p className="text-muted-foreground">{member.role}</p>
              {member.bio && <p className="text-sm mt-2 text-gray-600">{member.bio}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
